/* eslint-disable filenames/match-regex */
import { CURRENCY_SYMBOL } from '../../constants';
import { MINI_MENU_LINKS } from '../../links';

// Refer a Friend (RAF) - components > refer-a-friend
export const REFEREE_REGISTERED_BANNER = {
  heading: 'Thanks for using 5pm!',
  miniMenuRaf: MINI_MENU_LINKS.RAF,
  startReferring: 'Click here to refer',
  text: 'Since you’re an existing 5pm customer, you cannot be referred. But you can refer your friends!',
};
export const REFEREE_WELCOME_BANNER = {
  creditAddedText: (referralCredit) =>
    `You have now had ${CURRENCY_SYMBOL}${referralCredit} 
      credit added to your wallet. Make a purchase for your friend to receive their 
      ${CURRENCY_SYMBOL}${referralCredit}.`,
  startShopping: 'Start Shopping!',
  welcomeBigText: 'Welcome',
  welcomeSubHeading: 'to the Club!',
};
export const REFER_FRIEND_BANNER = {
  creditAmountPrice: `${CURRENCY_SYMBOL}200 credit`,
  creditAmountText: 'Get up to ',
  inviteFriends: 'Invite Friends',
  miniMenuRaf: MINI_MENU_LINKS.RAF,
  referYourFriends: 'Refer your friends',
};
export const TRACKING_INFO = {
  rafCancelInfo:
    'Any balance shown for cancelled referrals represents the credit not received in the event your friend refunded their order',
  rafPendingInfo: `Any balance shown for pending referrals represents the credit you are due after your friends' 14 day refund window passes (without a refund)`,
  referralLinksOpened: '# Links Opened',
  referralLinksShared: '# Links Shared',
  referrals: 'Referrals',
};
